module.exports = __webpack_public_path__ + "img/爸爸带孩子.8a19a467.png";